<template>
  <div class="my-auto">
    <div
      :class="
        $store.state.theme.display_profile_complete == '1'
          ? 'progress-bar-circle shadow-sm'
          : ''
      "
      :id="
        $store.state.theme.display_profile_complete == '1' && 'circle-progress'
      "
      data-test="profile-completion-circle"
    >
      <div
        @click="modalQR"
        v-if="userProfile.pictureUrl"
        class="profile-img"
        v-bind:style="{
          backgroundImage: 'url(' + userProfile.pictureUrl + ')'
        }"
        data-test="profile-avatar-img"
      ></div>
      <div
        @click="modalQR"
        v-else-if="profile.picture"
        class="profile-img"
        v-bind:style="{
          backgroundImage: 'url(' + profile.picture + ')'
        }"
        data-test="profile-avatar-img"
      ></div>
      <div
        @click="modalQR"
        v-else
        class="profile-img default"
        data-test="profile-avatar-img"
      >
        <div class="empty-picture">{{ profile.first_name_th[0] }}</div>
      </div>
    </div>
  </div>
  <!-- <ModalQRUser
    ref="modalqr"
    :profile="profile"
    :userProfile="userProfile"
    class="mx-2"
  /> -->
</template>

<script>
export default {
  props: {
    userProfile: { required: true, type: Object },
    profile: { required: true, type: Object }
  },
  mounted() {
    // this.emitter.on("openProfileModal", this.modalQR);
  },
  methods: {
    modalQR() {
      this.emitter.emit("openProfileModal");
    }
  }
};
</script>

<style>
.profile-img {
  position: absolute;
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid black;
  border-radius: 50%;
  left: 4px;
  top: 4px;
}
.profile-img.default {
  background-color: var(--primary-color);
  color: var(--font-primary-color);
  left: 0px;
  top: 0px;
}
.empty-picture {
  position: absolute;
  top: 55%;
  left: 50%;
  font-size: 42px;
  transform: translate(-50%, -55%);
}
</style>
